import { t } from '@lingui/macro';
import { I18n } from '@lingui/core';

export const getMeanWindowOptions = (i18n: I18n): { label: string; value: string | null }[] => {
  return [
    {
      label: t(i18n)`Dato bruto`,
      value: null,
    },
    {
      label: t(i18n)`1 minuto`,
      value: '1m',
    },
    {
      label: t(i18n)`5 minutos`,
      value: '5m',
    },
    {
      label: t(i18n)`10 minutos`,
      value: '10m',
    },
    {
      label: t(i18n)`15 minutos`,
      value: '15m',
    },
    {
      label: t(i18n)`30 minutos`,
      value: '30m',
    },
    {
      label: t(i18n)`1 hora`,
      value: '1h',
    },
    {
      label: t(i18n)`6 horas`,
      value: '6h',
    },
    {
      label: t(i18n)`12 horas`,
      value: '12h',
    },
    {
      label: t(i18n)`1 día`,
      value: '1d',
    },
    {
      label: t(i18n)`3 días`,
      value: '3d',
    },
  ];
};

export const getMeanWindowLabel = (meanWindow: string | null, i18n: I18n) => {
  const options = getMeanWindowOptions(i18n);
  const label = options.find((option) => option.value === meanWindow)?.label;
  if (!label) throw new Error('Label not listed on meanWindow options for reports');
  return label;
};
